<template>
  <div class="accept-invitation">
    <div
      v-if="invitationList.length == 0 || loadingInformation"
      class="d-flex justify-content-center"
    ><b-spinner /></div>
    <div v-if="invitationList.length > 0" class="accept-invitation-list">
      <template v-if="invitationList.length > 1">
        <div
          v-for="invitation in invitationList"
          :key="invitation.inviteId"
          class="accept-invitation-list-item d-flex justify-content-between flex-nowrap mb-2 pb-2 border-bottom"
        >
          <div class="decription">{{ `Accept the invitation to ${invitation.agencyName} Agency.` }}</div>
          <div class="actions d-flex align-items justify-content-end">
            <b-button
              variant="success"
              pill
              size="sm"
              :disabled="isInAction"
              @click="acceptInvitation(invitation)"
            >
              <b-icon-check v-if="!isInAction"></b-icon-check>
              <b-spinner v-else small></b-spinner>
            </b-button>
            <b-button
              variant="danger"
              pill
              size="sm"
              class="ml-2"
              :disabled="isInAction"
              @click="declineInvitation(invitation)"
            >
              <b-icon-x v-if="!isInAction"></b-icon-x>
              <b-spinner v-else small></b-spinner>
            </b-button>
          </div>
        </div>
      </template>
      <h5 v-else-if="invitationList.length == 1">{{ `Accept the invitation to ${invitationList[0].agencyName} Agency.` }}</h5>
    </div>
    <div v-if="invitationList.length > 0" class="accept-invitation-actions d-flex align-items-center justify-content-end mt-3">
      <b-button
        variant="success"
        pill
        style="width: 120px"
        :disabled="isInAction || invitationList.length == 0"
        @click="acceptAllInvitations"
      >
        <template v-if="!isInAction">
          {{ invitationList.length > 1 ? `Accept All` : 'Accept' }}
        </template>
        <b-spinner v-else small></b-spinner>
      </b-button>
      <b-button
        variant="danger"
        pill
        class="ml-2"
        style="width: 120px"
        :disabled="isInAction || invitationList.length == 0"
        @click="declineAllInvitations"
      >
        <template v-if="!isInAction">
          {{ invitationList.length > 1 ? `Decline All` : 'Decline' }}
        </template>
        <b-spinner v-else small></b-spinner>
      </b-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";

export default {
  name: "AcceptInvitation",
  data() {
    return {
      invitationList: [],
      isInAction: false,
      inviteIdInAction: null,
      loadingInformation: false,
      newAgencies: [],
    };
  },
  computed: {
    ...mapGetters("user", ["currentToken", "pendingInvitations", "currentUser"]),
    agencyTitle() {
      if (this.invitationList.length == 1) {
        return this.invitationList[0].agencyName;
      }
      return "";
    },
  },
  created() {
    this.loadingInformation = true;
    const currentPendingInvitations = [...this.pendingInvitations];
    const agencyIds = [...new Set(currentPendingInvitations.map(i => i.agency_id))];
    Promise.all(agencyIds.map(agencyId => this.$ConveyApi.agenciesApi.getAgency({ agencyId }))).then(results => {
      this.loadingInformation = false;
      this.newAgencies = results.map(result => result.data.data);
      this.invitationList = currentPendingInvitations.map(invitation => {
        const { agency_id, invite_id, first_name, last_name, email } = invitation;
        return {
          inviteId: invite_id,
          agencyId: agency_id,
          agencyName: this.getAgencyName(agency_id),
          fname: first_name,
          lname: last_name,
          email,
        }
      })
    }).catch(err => {
      console.log(err);
      this.newAgencies = [];
      this.loadingInformation = false;
    });
  },
  methods: {
    getAgencyName(agencyId) {
      const agency = this.newAgencies.find(a => a.agency_id == agencyId);
      return agency ? agency.agency_name : 'Unknown';
    },
    acceptInvitation(invitation) {
      const { inviteId, agencyId, agencyName } = invitation;
      this.isInAction = true;
      this.inviteIdInAction = inviteId;
      this.$ConveyApi.invitationsApi.fulfillInvitation({ inviteId, agencyId, payload: {} }).then(res => {
        this.$toastr("success", `Joining ${agencyName} Agency went successfully.`);
        if (!this.currentUser.agencies || this.currentUser.agencies.length === 0) {
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          this.$store.commit("user/setCurrentUser", res.data.data);
          this.isInAction = false;
          this.inviteIdInAction = null;
          this.removeInvitationFromList(invitation);
        }
      }).catch(err => {
        console.log(err);
        this.isInAction = false;
        this.inviteIdInAction = null;
        this.$toastr("error", `Joining ${agencyName} Agency went wrong. Please try again.`);
      });
    },
    acceptAllInvitations() {
      this.isInAction = true;
      this.inviteIdInAction = null;
      Promise.all(
        this.invitationList.map(i => {
          const { inviteId, agencyId } = i;
          return this.$ConveyApi.invitationsApi.fulfillInvitation({ inviteId, agencyId, payload: {} });
        })
      )
        .then((res) => {
          this.isInAction = false;
          this.$toastr(
            "success",
            `Joining ${this.invitationList.length > 1 ? 'agencies' : `${this.invitationList[0].agencyName} Agency`} went successfully.`,
          );
          if (!this.currentUser.agencies || this.currentUser.agencies.length === 0) {
            setTimeout(() => {
              window.location.reload();
            }, 3000)
          } else {
            this.updateCurrentUser();
            this.removeInvitationFromList();
          }
        })
        .catch((err) => {
          console.log(err);
          this.isInAction = false;
          this.$toastr(
            "error",
            `Joining ${this.invitationList.length > 1 ? 'agencies' : `${this.invitationList[0].agencyName} Agency`} went wrong. Please try again.`
          );
        });
    },
    declineAllInvitations() {
      this.isInAction = true;
      this.inviteIdInAction = null;
      Promise.all(
        this.invitationList.map(i => {
          const { inviteId, agencyId } = i;
          return this.$ConveyApi.invitationsApi.revokeInvitation({ inviteId, agencyId });
        })
      )
        .then((res) => {
          this.isInAction = false;
          this.$toastr(
            "info",
            `Declined invitations to ${this.invitationList.length > 1 ? 'agencies' : `${this.invitationList[0].agencyName} Agency`} went successfully.`,
          );
          this.updateCurrentUser();
          this.removeInvitationFromList();
        })
        .catch((err) => {
          console.log(err);
          this.isInAction = false;
          this.$toastr(
            "error",
            `Declining invitations to ${this.invitationList.length > 1 ? 'agencies' : `${this.invitationList[0].agencyName} Agency`} went wrong. Please try again.`
          );
        });
    },
    declineInvitation(invitation) {
      const { inviteId, agencyId, agencyName } = invitation;
      this.isInAction = true;
      this.inviteIdInAction = inviteId;
      this.$ConveyApi.invitationsApi.revokeInvitation({ inviteId, agencyId }).then(res => {
        this.isInAction = false;
        this.inviteIdInAction = null;
        this.$toastr("info", `Declined invitation to ${agencyName} Agency.`);
        this.updateCurrentUser();
        this.removeInvitationFromList(invitation);
      }).catch(err => {
        console.log(err);
        this.isInAction = false;
        this.inviteIdInAction = null;
        this.$toastr("error", `Declining invitation to ${agencyName} Agency went wrong. Please try again.`);
      });
    },
    removeInvitationFromList(invitation = null) {
      if (invitation) {
        const { inviteId } = invitation;
        const invitationIndex = this.invitationList.findIndex(
          (i) => i.inviteId == inviteId
        );
        if (invitationIndex > -1) {
          this.invitationList.splice(invitationIndex, 1);
        }
        if (this.invitationList.length == 0) {
          this.$store.commit("user/setPendingInvitations", []);
          EventBus.$emit("close-modal");
        } else {
          const currentPendingInvitations = [...this.pendingInvitations];
          const removedInvitationIndex = currentPendingInvitations.findIndex(i => i.invite_id === invitation.inviteId);
          if (removedInvitationIndex > -1) {
            currentPendingInvitations.splice(removedInvitationIndex, 1);
          }
          this.$store.commit("user/setPendingInvitations", currentPendingInvitations);
        }
        this.$store.commit("user/setPendingInvitations", []);
      } else {
        this.invitationList = [];
        this.$store.commit("user/setPendingInvitations", []);
        EventBus.$emit("close-modal");
      }
    },
    updateCurrentUser() {
      this.$ConveyApi.usersApi.getCurrentUser()
        .then(res => {
          this.$store.commit("user/setCurrentUser", res.data.data);
        }).catch(err => {
          console.log(err);
        });
    }
  },
};
</script>

<style lang="scss">
.accept-invitation {
  &-list {
    &-item {
      gap: 8px;
      .description {
        font-size: 1rem;
      }
      .actions {
        >button {
          width: 27px !important;
          height: 27px !important;
          padding: 4px;
          line-height: 1 !important;
        }
      }

      &:last-child {
        border: none !important;
        margin-bottom: 0 !important;
      }
    }
  }
}
</style>
